export enum AppRoles {
  Suspended = 0,
  User = 1,
  Admin = 3,
}

export enum Providers {
  Google = 'google.com',
  Microsoft = 'microsoft.com',
  Password = 'password',
}
